export default __webpack_public_path__ + "static/media/990.d200611a.png";